import React from "react";

const RenderReportStatus = ({ report, isFacilitator = false }) => {
    let display = "";
    let textClass = "";

    const status = report?.status ?? "";

    switch (status) {
        case "review":
            display = "Under review";
            break;

        case "completed":
            display = "Available";
            textClass = "success";
            break;

        default:
            display = "Not available";
            break;
    }

    return <span className={textClass}>{display}</span>;
};

export default RenderReportStatus;
